import { FieldValue } from 'firebase/firestore';

// Keep explicit false/zero/empty/null values and Firestore write sentinels.
// Version dates remain readable strings; absent dates remain absent.
export function cleanConfigurationData(value) {
  if (value === null || value === undefined) return value;
  if (value instanceof FieldValue) return value;
  if (typeof value.toDate === 'function') return value.toDate().toISOString();
  if (value.path && value.id && value.firestore) return value.path;
  if (Array.isArray(value)) {
    return value.filter(item => item !== undefined).map(cleanConfigurationData);
  }
  if (typeof value === 'object' && !(value instanceof Date)) {
    return Object.fromEntries(Object.entries(value)
      .filter(([, item]) => item !== undefined)
      .map(([key, item]) => [key, cleanConfigurationData(item)]));
  }
  return value;
}

export function cleanConfigurationSnapshot(value) {
  const {
    versions, id, createdAt, updatedAt, updatedBy, publishedVersion, isLocked,
    ...snapshot
  } = cleanConfigurationData(value) || {};
  return snapshot;
}

export function configurationSnapshot(value, metadata) {
  return { ...cleanConfigurationSnapshot(value), ...metadata };
}
